// Angular
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function isEmailValidator(): ValidatorFn {
// Define the regex pattern for validating email
  // eslint-disable-next-line no-control-regex
  const emailPattern = /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)])/;

// Return the validation function
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      // If no value is present, consider it valid
      return null;
    }
    // Test the value against the regex pattern
    return emailPattern.test(control.value) ? null : { isEmail: true };
  };
}
